import React, { useEffect, useState } from "react"
import _get from "lodash/get"
import { useSelector } from "react-redux"

import Input from "@/components/core/Input/Input"
import Button from "@/components/core/Button/Button"
import Dropdown from "@/components/core/SelectDropdown/SelectDropdown"

import { validateField } from "@/utils/helper"
import { selectAuthState } from "@/store/features/authSlice"

export const EditProfileform = ({
  i18n = {},
  data: propData = {},
  businessList = [],
  addDataLayerEditProfile = () => {},
  onEdit = () => {},
  showModal = false,
  ...props
}) => {
  const { user } = useSelector(selectAuthState)
  const userType = user?.persona[0]?.split(":")

  const initialState = {
    firstName: {
      value: _get(propData, "firstName", ""),
      error: false,
      message: "",
    },
    lastName: {
      value: _get(propData, "lastName", ""),
      error: false,
      message: "",
    },
    email: {
      value: _get(propData, "email", ""),
    },
    businessName: {
      value: _get(propData, "companyName", ""),
      error: false,
      message: "",
    },
    businessType: {
      value: _get(propData, "custom.fields.businessType", ""),
      error: false,
      message: "",
    },
    businessSubType: {
      value: _get(propData, "custom.fields.businessSubType", ""),
      error: false,
      message: "",
    },
    businessZipCode: {
      value: _get(propData, "postalCode", ""),
      error: false,
      message: "",
    },
  }
  const [data, setData] = useState(initialState)
  const [disabled, setDisabled] = useState(false)
  useEffect(() => {
    if (!showModal) {
      setData(initialState)
    }
  }, [showModal])

  const handleSubmit = async () => {
    const obj = {}
    let valid = true
    if (
      data?.firstName?.value &&
      !(await validateField("name", data?.firstName?.value))
    ) {
      data.firstName = {
        value: data?.firstName?.value,
        error: true,
        message: i18n?.validFirstName,
      }
      valid = false
    } else if (data?.firstName?.value === "") {
      data.firstName = {
        value: data?.firstName?.value,
        error: true,
        message: i18n?.fnameError,
      }
      valid = false
    }
    if (
      data?.lastName?.value &&
      !(await validateField("name", data?.lastName?.value))
    ) {
      data.lastName = {
        value: data?.lastName?.value,
        error: true,
        message: i18n?.validLastName,
      }
      valid = false
    } else if (data?.lastName?.value === "") {
      data.lastName = {
        value: data?.lastName?.value,
        error: true,
        message: i18n?.lnameError,
      }
      valid = false
    }

    if (userType[1] === "TVS") {
      if (!data?.businessName?.value) {
        data.businessName = {
          value: data?.businessName?.value,
          error: true,
          message: i18n?.businessNameError,
        }
        valid = false
      }
      if (!data?.businessZipCode?.value) {
        data.businessZipCode = {
          value: data?.businessZipCode?.value,
          error: true,
          message: i18n?.zipCodeError,
        }
        valid = false
      } else if (
        data?.businessZipCode?.value?.length < 5 ||
        !(await validateField("zipcode", data?.businessZipCode?.value))
      ) {
        data.businessZipCode = {
          value: data?.businessZipCode?.value,
          error: true,
          message: i18n?.validZipcode,
        }
        valid = false
      }
      if (!data?.businessType?.value) {
        data.businessType = {
          value: data?.businessType?.value,
          error: true,
          message: i18n?.businessTypeError,
        }
        valid = false
      }
      if (
        data?.businessType?.value &&
        businessList.find(el => el.text === data?.businessType?.value)?.value &&
        !data?.businessSubType?.value
      ) {
        data.businessSubType = {
          value: data?.businessSubType?.value,
          error: true,
          message: i18n?.subTypeError,
        }
        valid = false
      }
    }
    const newData = { ...data, ...obj }
    setData(newData)
    if (!valid) {
      const errMsg = []
      for (const key in data) {
        if (data) {
          data[key]["message"] &&
            errMsg.push(data[key]["message"]?.toLowerCase())
        }
      }
      const errMessages = errMsg.length ? errMsg.join("|") : ""
      addDataLayerEditProfile(errMessages)
    }
    if (valid) {
      setDisabled(true)
      onEdit(data, handleCallBack)
    }
  }

  const handleCallBack = () => {
    setDisabled(false)
  }
  const { save = "" } = i18n
  return (
    <div className="address-form container px-0 mx-0">
      <span className="address-form__required-fields">
        {`${i18n?.requiredFields}`}
      </span>
      <div className="row">
        <div className="col-12">
          <Input
            id="firstName"
            type="text"
            maxLength={20}
            value={data?.firstName?.value}
            label={`${i18n?.firstName}*`}
            onChange={e =>
              setData({
                ...data,
                firstName: {
                  value: e.target.value.split(" ").join(""),
                  error: false,
                  message: "",
                },
              })
            }
            showError={data?.firstName?.error}
            errorMessage={data?.firstName?.message}
            autoFocus
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Input
            id="lastName"
            type="text"
            maxLength={20}
            value={data?.lastName?.value}
            label={`${i18n?.lastName}*`}
            onChange={e =>
              setData({
                ...data,
                lastName: {
                  value: e.target.value.split(" ").join(""),
                  error: false,
                  message: "",
                },
              })
            }
            showError={data?.lastName?.error}
            errorMessage={data?.lastName?.message}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Input
            type="text"
            value={data?.email?.value}
            label={
              userType[1] === "TVS"
                ? `${i18n?.businessEmailAddress}*`
                : `${i18n?.emailAddress}*`
            }
            disabled={true}
          />
        </div>
      </div>
      {userType[1] === "TVS" && (
        <div>
          <div className="row">
            <div className="col-12">
              <Input
                type="text"
                id="businessName"
                value={data?.businessName?.value}
                label={`${i18n?.businessName}*`}
                onChange={e =>
                  setData({
                    ...data,
                    businessName: {
                      value: e.target.value,
                      error: false,
                      message: "",
                    },
                  })
                }
                showError={data?.businessName?.error}
                errorMessage={data?.businessName?.message}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Dropdown
                data={businessList.map(el => el?.text)}
                label={`${i18n?.businessType}*`}
                value={data?.businessType?.value}
                customClass="address-form__select-dropdown"
                onChange={val =>
                  setData({
                    ...data,
                    businessType: {
                      value: val,
                      error: false,
                      message: "",
                    },
                    businessSubType: {
                      value: "",
                      error: false,
                      message: "",
                    },
                  })
                }
                showError={data?.businessType?.error}
                errorMessage={data?.businessType?.message}
              />
            </div>
          </div>
          {data?.businessType?.value &&
            businessList.find(el => el.text === data?.businessType?.value)
              .value && (
              <div className="row">
                <div className="col-12">
                  <Dropdown
                    data={
                      businessList
                        .find(el => el.text === data?.businessType?.value)
                        .value.split(",") ?? []
                    }
                    label={`${i18n?.businessSubType}*`}
                    value={data?.businessSubType?.value}
                    customClass="address-form__select-dropdown"
                    onChange={val =>
                      setData({
                        ...data,
                        businessSubType: {
                          value: val,
                          error: false,
                          message: "",
                        },
                      })
                    }
                    showError={data?.businessSubType?.error}
                    errorMessage={data?.businessSubType?.message}
                  />
                </div>
              </div>
            )}

          <div className="row">
            <div className="col-12">
              <Input
                id="businessZipCode"
                type="text"
                value={data?.businessZipCode?.value}
                label={`${i18n?.businessZipCode}*`}
                onChange={e =>
                  setData({
                    ...data,
                    businessZipCode: {
                      value: e.target.value,
                      error: false,
                      message: "",
                    },
                  })
                }
                showError={data?.businessZipCode?.error}
                errorMessage={data?.businessZipCode?.message}
              />
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-12">
          <Button
            customClass="edit-profile-modal__submit"
            useDefaultClass={true}
            type="black"
            disabled={disabled}
            label={save}
            size="large"
            flexible={true}
            onClick={() => {
              handleSubmit()
            }}
            role="button"
          />
        </div>
      </div>
    </div>
  )
}

export default EditProfileform
